import { render, staticRenderFns } from "./ModalEditarExpiracao.vue?vue&type=template&id=529279d6&"
import script from "./ModalEditarExpiracao.vue?vue&type=script&lang=js&"
export * from "./ModalEditarExpiracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports